import * as React from 'react';

const Board24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M19 3.49951C20.5186 3.49959 21.7499 4.73089 21.75 6.24951V17.2495C21.75 18.7682 20.5187 19.9994 19 19.9995H5C3.48122 19.9995 2.25 18.7683 2.25 17.2495V6.24951C2.25013 4.73084 3.4813 3.49951 5 3.49951H19ZM5 4.99951C4.30973 4.99951 3.75013 5.55927 3.75 6.24951V17.2495C3.75 17.9399 4.30964 18.4995 5 18.4995H8.25V4.99951H5ZM9.75 18.4995H14.25V4.99951H9.75V18.4995ZM15.75 18.4995H19C19.6903 18.4994 20.25 17.9398 20.25 17.2495V6.24951C20.2499 5.55932 19.6902 4.99959 19 4.99951H15.75V18.4995Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export default Board24;
